import { createFileRoute } from "@tanstack/react-router";
import IceStorms from "@/pages/IceStorms";
import { seo, breadcrumbSchema } from "@/lib/seo";

export const Route = createFileRoute("/_site/ice-storms")({
  head: () =>
    seo({
      title: "Ice Dam Removal & Winter Roof Repair in Minnesota",
      description:
        "Ice dam removal, ice & water shield, and attic ventilation fixes for Minnesota winters. Stop interior leaks fast—call (612) 298-9865.",
      path: "/ice-storms",
      jsonLd: breadcrumbSchema([
        { name: "Home", path: "/" },
        { name: "Ice Storms", path: "/ice-storms" },
      ]),
    }),
  component: IceStorms,
});
